import * as React from 'react';

import InfoImg from '../../assets/images/certificates/information.png';
import InfoGreyImg from '../../assets/images/certificates/information_grey.png';

export default function InformationIcon({ white }) {
    return (
        <img
            style={{
                height: '20px',
            }}
            src={white ? InfoImg : InfoGreyImg}
            alt="information"
        />
    );
}
